import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { IntentType } from '@debbie/common/dist/intents';
import Button from '../Button';
import Modal from '../Modal';
import DepositIntent from './DepositIntent';
import IntentCreator from './IntentCreator';
import UnknownIntent from './UnknownIntent';
const Wrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const IntentWrapper = styled.div `
  width: 100%;
`;
const intentMap = {
    [IntentType.Unknown]: UnknownIntent,
    [IntentType.Deposit]: DepositIntent,
};
const Intent = (props) => {
    const [editing, setEditing] = useState(false);
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Wrapper, null,
        React.createElement(IntentWrapper, null, React.createElement(intentMap[props.intent.type], {
            intent: props.intent,
        })),
        props.editable && (React.createElement(React.Fragment, null,
            React.createElement(Button, { size: "small", theme: "secondary", onClick: () => setEditing(true) }, lang.misc.edit),
            editing && (React.createElement(Modal, { header: lang.intents.intent, onToggle: () => {
                    setEditing(false);
                }, maxWidth: "450px" },
                React.createElement(IntentCreator, { onCreate: (intent) => {
                        setEditing(false);
                        props.onEdit && props.onEdit(intent);
                    } })))))));
};
export default Intent;
//# sourceMappingURL=Intent.js.map